import React from 'react';
import { Leaf } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Card, CardContent } from '../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { Search, X } from 'lucide-react';

export const ProductFilters = ({ search, setSearch, categoryFilter, setCategoryFilter, statusFilter, setStatusFilter, categories, setCurrentPage }) => (
    <Card className="mb-6 border-0 bg-white/80 backdrop-blur-sm shadow-sm rounded-2xl">
        <CardContent className="pt-6">
            <div className="flex flex-col sm:flex-row gap-4">
                <div className="relative flex-1">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                    <Input
                        placeholder="Rechercher un produit ou code..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="pl-10 bg-white/80 border-jungle/20 rounded-xl"
                        data-testid="search-input"
                    />
                </div>
                <Select value={categoryFilter} onValueChange={(v) => { setCategoryFilter(v); setCurrentPage(1); }}>
                    <SelectTrigger className="w-full sm:w-[180px] border-jungle/20 rounded-xl">
                        <SelectValue placeholder="Famille" />
                    </SelectTrigger>
                    <SelectContent className="bg-white/95 backdrop-blur-xl">
                        <SelectItem value="all">Toutes familles</SelectItem>
                        {categories.map((cat) => (
                            <SelectItem key={cat.id} value={cat.id}>{cat.name}</SelectItem>
                        ))}
                    </SelectContent>
                </Select>
                <Select value={statusFilter} onValueChange={(v) => { setStatusFilter(v); setCurrentPage(1); }}>
                    <SelectTrigger className="w-full sm:w-[180px] border-jungle/20 rounded-xl">
                        <SelectValue placeholder="Statut" />
                    </SelectTrigger>
                    <SelectContent className="bg-white/95 backdrop-blur-xl">
                        <SelectItem value="all">Tous les statuts</SelectItem>
                        <SelectItem value="active">Actifs seulement</SelectItem>
                        <SelectItem value="inactive">Masqués seulement</SelectItem>
                        <SelectItem value="weekly">Offres semaine</SelectItem>
                        <SelectItem value="orderable">Prets a commander</SelectItem>
                        <SelectItem value="not_orderable">Non prets a commander</SelectItem>
                    </SelectContent>
                </Select>
                {(search || categoryFilter !== 'all' || statusFilter !== 'all') && (
                    <Button
                        variant="ghost"
                        onClick={() => { setSearch(''); setCategoryFilter('all'); setStatusFilter('all'); setCurrentPage(1); }}
                        className="text-destructive hover:bg-destructive/10 rounded-xl"
                    >
                        <X className="h-4 w-4 mr-2" />
                        Effacer
                    </Button>
                )}
            </div>
        </CardContent>
    </Card>
);
